import React from "react";

/* img imports */
import doctorsBoard from "../assets/images/doctors-board.png";

const DoctorsBoard = ({ handleRedirect }) => {
  return (
    <>
      <div
        className="doctors-board-wrapper"
        onClick={() => {
          handleRedirect("/doctors");
        }}
      >
        <img src={doctorsBoard} alt="" />
      </div>
    </>
  );
};

export default DoctorsBoard;
